import React, {useState, useEffect} from 'react';
import {formatDate, textTruncateByLength} from 'utils/other';
import {Input} from 'reactstrap';
import './style.scss';
import Loader from 'components/Loader';
import NewsTicker, {Directions} from 'react-advanced-news-ticker';

function NewsList(props) {
    const [searchValue, setSearchValue] = useState('');
    const [visibleNews, changeVisibleNews] = useState([]);
    const [itemsShown, setShownItems] = useState(100);

    useEffect(() => {
        changeVisibleNews(props.news);
        setShownItems(100);
        setSearchValue('');
    }, [props.news]);

    const handleSearchChange = (value) => {
        if(value === '') {
            setSearchValue('');
            changeVisibleNews([...props.news]);
        } else {
            const visibleList = props.news.filter(item =>
                item.title.toLowerCase().includes(value.toLowerCase()) ||
                (item.abstract && item.abstract.toLowerCase().includes(value.toLowerCase())),
            );
            changeVisibleNews(visibleList);
            setSearchValue(value);
        }
    };

    return (
        <div className="news_list-container">
            <div className="reader-block_header-container">
                <h2 className="reader-block_header">Articles</h2>
            </div>
            {props.news.length > 0 &&
            <div className="reader-input-container">
                <Input
                    onChange={(e) => handleSearchChange(e.target.value)}
                    value={searchValue}
                    placeholder="Search by article"
                    type="text"
                    className="searchInput reader-input"
                />
                {!searchValue ?
                    <i style={{cursor: 'default'}} className="fa fa-search search-container_icon"/>
                    :
                    <i onClick={() => handleSearchChange('')} className="fa fa-times-circle search-container_icon"/>
                }
            </div>
            }
            {props.newsLoading ? (
                <div className="reader-list_loader-container" style={{borderTop: '1px solid rgb(49, 71, 132)'}}>
                    {/*<i className="fa fa-spinner fa-spin" />*/}
                    <Loader small/>
                </div>
            ) : (
                <div className="news_list-list_container">
                    {(visibleNews && visibleNews.length > 0) ?
                        visibleNews.map((item, index) => {
                            return index < itemsShown && (
                                <div
                                    className="news_list-list_item-container"
                                    style={{backgroundColor: item.id === props.selectedNewsItem.id ? 'white' : 'rgb(228, 229, 230)'}}
                                    onClick={() => props.selectNews(item.id)}
                                    key={item.id}
                                >
                                    <div className="news_list-list_item-date">
                                        <div>{item.domain}</div>
                                        <div>{item.publishedAt ? formatDate(item.publishedAt) : ''}</div>
                                    </div>
                                    <div className="news_list-list_item-title">
                                        {textTruncateByLength(item.title, 75)}
                                    </div>
                                    <div>{item.abstract_short ? textTruncateByLength(item.abstract, 300) : ''}</div>
                                </div>
                            );
                        })
                        :
                        <div style={{padding: '10px 15px'}}>
                            No Articles found
                        </div>
                    }
                    {(visibleNews && visibleNews.length > itemsShown) &&
                    <div className="news_list-list-show_more" onClick={() => setShownItems(itemsShown + 100)}>
                        Show more...
                    </div>
                    }
                </div>
            )}
            <div
                className="reader-block_footer-container flex-centered"
                style={{
                    borderTop: '1px solid rgb(49, 71, 132)',
                    borderBottom: '1px solid rgb(49, 71, 132)',
                    backgroundColor: 'rgb(228, 229, 230)',
                }}
            >
                <div>{(visibleNews && visibleNews.length) ? visibleNews.length : 'No'} Articles</div>
            </div>
        </div>
    );
}

export default NewsList;


{/*<div className="news_list-list_container">*/
}
{/*    {(visibleNews && visibleNews.length > 0) ?*/
}
{/*        {<NewsTicker*/
}
{/*            rowHeight={94}*/
}
{/*            maxRows={10000}*/
}
{/*            speed={600}*/
}
{/*            direction={Directions.UP}*/
}
{/*            duration={2500}*/
}
{/*            autoStart={true}*/
}
{/*            pauseOnHover={false}*/
}
{/*            style={{listStyle: 'none', paddingLeft: 0}}*/
}
{/*        >*!/*/
}
{/*            {visibleNews.map((item, index) => {*/
}
{/*                return index < itemsShown && (*/
}
{/*                    <div*/
}
{/*                        className="news_list-list_item-container"*/
}
{/*                        style={{backgroundColor: item.id === props.selectedNewsItem.id ? 'white' : 'rgb(228, 229, 230)'}}*/
}
{/*                        onClick={() => props.selectNews(item.id)}*/
}
{/*                        key={item.id}*/
}
{/*                    >*/
}
{/*                        <div className="news_list-list_item-date">*/
}
{/*                            <div>{item.domain}</div>*/
}
{/*                            <div>{item.publishedAt ? formatDate(item.publishedAt) : ''}</div>*/
}
{/*                        </div>*/
}
{/*                        <div className="news_list-list_item-title">*/
}
{/*                            {textTruncateByLength(item.title, 75)}*/
}
{/*                        </div>*/
}
{/*                        <div>{item.abstract_short ? textTruncateByLength(item.abstract, 300) : ''}</div>*/
}
{/*                    </div>*/
}
{/*                );*/
}
{/*            })}*/
}
{/*            /!*</NewsTicker>*!/*/
}
{/*            :*/
}
{/*            <div style={{padding: '10px 15px'}}>*/
}
{/*                No Articles found*/
}
{/*            </div>*/
}
{/*            }*/
}
{/*            {(visibleNews && visibleNews.length > itemsShown) &&*/
}
{/*            <div className="news_list-list-show_more" onClick={() => setShownItems(itemsShown + 100)}>*/
}
{/*                Show more...*/
}
{/*            </div>*/
}
{/*            }*/
}
{/*        </div>*/
}